import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  JobSummaryDto,
  CreateJobRequest,
  JobGetDto,
  GetDashboardInfoByUserRequest,
  DashboardInfoDto,
  DashboardInfoRow,
  JobDetailDto,
  PartItemDetailDto,
  ActionCodeDto,
  CodeDto,
  LotNumberGetDto,
  EmptyResponse,
  Error,
  UpdateJobRequest,
  DocumentSummaryDto,
  UpdatePartKitRequest,
  UpdatePartKitLotNumberRequest,
  JobField,
  UpdateRepairServicePerformedRequest,
  OptionItemDto,
  PartItemSummaryDto,
  UpdatePartsListRequest,
  UpdateReplacedPartsRequest,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class JobsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getAll(
    params: {
      /**  */
      id?: number;
      /**  */
      partnerSiteId?: number;
      /**  */
      createdDate?: Date;
      /**  */
      levelOfServiceCodeId?: number;
      /**  */
      jobStatus?: string;
      /**  */
      evaluationIsRepairable?: string;
      /**  */
      serialNumber?: string;
      /**  */
      partNumber?: string;
      /**  */
      assetNumber?: string;
      /**  */
      clientName?: string;
      /**  */
      reference1?: string;
      /**  */
      evaluationQuoteStatus?: string;
      /**  */
      reviewStatus?: string;
      /**  */
      certScrapReport?: string;
      /**  */
      evaluationCompleteFromDate?: Date;
      /**  */
      evaluationCompleteToDate?: Date;
      /**  */
      closedArchivedFromDate?: Date;
      /**  */
      closedArchivedToDate?: Date;
      /**  */
      createdFromDate?: Date;
      /**  */
      createdToDate?: Date;
      /**  */
      jobType?: string;
      /**  */
      isHistory?: boolean;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<JobSummaryDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Id: params['id'],
        PartnerSiteId: params['partnerSiteId'],
        CreatedDate: params['createdDate'],
        LevelOfServiceCodeId: params['levelOfServiceCodeId'],
        JobStatus: params['jobStatus'],
        EvaluationIsRepairable: params['evaluationIsRepairable'],
        SerialNumber: params['serialNumber'],
        PartNumber: params['partNumber'],
        AssetNumber: params['assetNumber'],
        ClientName: params['clientName'],
        Reference1: params['reference1'],
        EvaluationQuoteStatus: params['evaluationQuoteStatus'],
        ReviewStatus: params['reviewStatus'],
        CertScrapReport: params['certScrapReport'],
        EvaluationCompleteFromDate: params['evaluationCompleteFromDate'],
        EvaluationCompleteToDate: params['evaluationCompleteToDate'],
        ClosedArchivedFromDate: params['closedArchivedFromDate'],
        ClosedArchivedToDate: params['closedArchivedToDate'],
        CreatedFromDate: params['createdFromDate'],
        CreatedToDate: params['createdToDate'],
        JobType: params['jobType'],
        IsHistory: params['isHistory'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateJobRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<JobGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDashboardInfo(
    params: {
      /**  */
      request?: GetDashboardInfoByUserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<DashboardInfoDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/dashboard';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { request: params['request'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllJobsAsCsv(
    params: {
      /**  */
      id?: number;
      /**  */
      partnerSiteId?: number;
      /**  */
      createdDate?: Date;
      /**  */
      levelOfServiceCodeId?: number;
      /**  */
      jobStatus?: string;
      /**  */
      evaluationIsRepairable?: string;
      /**  */
      serialNumber?: string;
      /**  */
      partNumber?: string;
      /**  */
      assetNumber?: string;
      /**  */
      clientName?: string;
      /**  */
      reference1?: string;
      /**  */
      evaluationQuoteStatus?: string;
      /**  */
      reviewStatus?: string;
      /**  */
      certScrapReport?: string;
      /**  */
      evaluationCompleteFromDate?: Date;
      /**  */
      evaluationCompleteToDate?: Date;
      /**  */
      closedArchivedFromDate?: Date;
      /**  */
      closedArchivedToDate?: Date;
      /**  */
      createdFromDate?: Date;
      /**  */
      createdToDate?: Date;
      /**  */
      jobType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<string>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/csv';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Id: params['id'],
        PartnerSiteId: params['partnerSiteId'],
        CreatedDate: params['createdDate'],
        LevelOfServiceCodeId: params['levelOfServiceCodeId'],
        JobStatus: params['jobStatus'],
        EvaluationIsRepairable: params['evaluationIsRepairable'],
        SerialNumber: params['serialNumber'],
        PartNumber: params['partNumber'],
        AssetNumber: params['assetNumber'],
        ClientName: params['clientName'],
        Reference1: params['reference1'],
        EvaluationQuoteStatus: params['evaluationQuoteStatus'],
        ReviewStatus: params['reviewStatus'],
        CertScrapReport: params['certScrapReport'],
        EvaluationCompleteFromDate: params['evaluationCompleteFromDate'],
        EvaluationCompleteToDate: params['evaluationCompleteToDate'],
        ClosedArchivedFromDate: params['closedArchivedFromDate'],
        ClosedArchivedToDate: params['closedArchivedToDate'],
        CreatedFromDate: params['createdFromDate'],
        CreatedToDate: params['createdToDate'],
        JobType: params['jobType']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<JobDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateJobRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<JobGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBlankJobForm(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<DocumentSummaryDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/blank-job-form';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateBlankJobForm(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/blank-job-form';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateCosReport(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/cos-report';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateCosReportPartnerSite(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/cos-report-partner-site';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateUecocReport(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/uecoc-report';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateUecocReportPartnerSite(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/uecoc-report-partner-site';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateScrapReportPartnerSite(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/scrap-report-partner-site';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateScrapReport(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/scrap-report';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateRepairSummaryReport(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/reports/repair-summary-report';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateDailySummaryReport(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/reports/daily-summary-report';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updatePartKit(
    params: {
      /**  */
      jobId: number;
      /** requestBody */
      body?: UpdatePartKitRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/part-kit/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updatePartKitLotNumber(
    params: {
      /**  */
      jobId: number;
      /** requestBody */
      body?: UpdatePartKitLotNumberRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/part-kit-lot-number/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getJobFields(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<JobField>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/repair-service-performed';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateRepairServicePerformed(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateRepairServicePerformedRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/{id}/repair-service-performed';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSerialNumberOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto<string>>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/serial-numbers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPartKitOptionsByJobId(
    params: {
      /**  */
      jobId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<OptionItemDto<string>>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/part-kits/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPartItemsWithRequiredLotNumberByJobId(
    params: {
      /**  */
      jobId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<PartItemDetailDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/parts-list-required-lot/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPartsListByJobId(
    params: {
      /**  */
      jobId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<PartItemSummaryDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/parts-list/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updatePartsList(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdatePartsListRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/parts-list/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateToLatestRevision(
    params: {
      /**  */
      jobId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<JobGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/parts-list-revision/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateReplacedParts(
    params: {
      /**  */
      jobId: number;
      /** requestBody */
      body?: UpdateReplacedPartsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<PartItemDetailDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/jobs/replaced-parts/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
